







import { Component, Prop, Vue } from 'vue-property-decorator';
import Header from "@/commonComponents/header/header.vue";
import PagePreview from './pagePreview/pagePreview.vue';
import TopController from './topController/topController.vue';
import TopControllerInsertion from './topControllerInsertion/topControllerInsertion.vue';
import RightController from './rightController/rightController.vue';
import RightControllerInsertion from './rightControllerInsertion/rightControllerInsertion.vue';
import PageController from '@/commonComponents/pageController/pageController.vue';
import DisplayController from './displayController/displayController.vue';
import ContextMenu from '@/commonComponents/contextMenu/contextMenu.vue';
import FileOpen from '@/commonComponents/fileOpen/fileOpen.vue';
import DeleteDesign from './deleteDesignModal/deleteDesignModal.vue';
import FontConvertModal from "@/commonComponents/alertModal/fontConvertModal/fontConvertModal.vue";
import Tutorial from "../tutorial/tutorial.vue";
import License from "../top2/mainContents/license/license.vue";
import LoadingScreen from "@/commonComponents/loadingScreen/loadingScreen.vue"

import * as def from '@/definitions'
// TODO document2
import { Const } from '@/const';
import { Document } from '@/model/document2/document';
import { Page } from '@/model/document2/page/page';
import { Design } from '@/model/document2/page/surface/design/design';
import { ClipboardManager } from "@/model/clipboardManager/clipboardManager";

// Command
import { CopyDesignCommand } from '@/commands/copyDesignCommand';
import { CopyMultiDesignCommand } from '@/commands/copyMultiDesignCommand';
import { DeleteDesignCommand } from '@/commands/deleteDesignCommand';
import { NewPageCommand } from '@/commands/newPageCommand';
import { DeletePageCommand } from '@/commands/deletePageCommand';
import { NewDesignCommand } from '@/commands/newDesignCommand';
import { DuplicateDesignCommand } from '@/commands/duplicateDesignCommand';
import { RotateDocumentCommand } from '@/commands/rotateDocumentCommand';

import { FileConverter } from '@/label_convert/fileConverter';

// Helper
import { FileHelper } from '@/helper/fileHelper'
import { EncryptionHelper } from "@/helper/encryptionHelper"
import { ArrayHelper } from "@/helper/arrayHelper"
import { ShortcutManager } from '@/model/shortcutManager/shortcutManager';
import { InsertionHelper } from '@/helper/insertionHelper';
import { NameHelper } from '@/helper/nameHelper';
import { DocumentHelper } from '@/helper/documentHelper';
import { CookieHelper } from "@/helper/cookieHelper";
import { DebugHelper } from "@/helper/debugHelper";
import { FontHelper } from '@/helper/fontHelper';
import { LogHelper } from "@/helper/logHelper";
import { NativeHelper } from '@/helper/nativeHelper';

@Component({
    components: {
        Header,
        PagePreview,
        TopController,
        TopControllerInsertion,
        RightController,
        RightControllerInsertion,
        PageController,
        DisplayController,
        ContextMenu,
        FileOpen,
        DeleteDesign,
        FontConvertModal,
        Tutorial,
        License,
        LoadingScreen
    },
})

//******************************************//
//**************** モバイル用 ****************//
//******************************************//
export default class LayoutEditor extends Vue
{
    // ドキュメントのロード終了フラグ
    // モバイルではこのフラグがオンになるまでは表示させない
    private isLoadedDocument = false;

    private get currentTab() { return "/LayoutEditor"; }

    private get paperInfoText() { return DocumentHelper.getPaperInfoText(this.currentDocument); }

    // ドラッグ中のアイテムポジション
    private draggingItemPosition : number = -1;
    // ドラッグ中の素材
    private draggingMaterialIndex : number = -1;

    // ズーム
    private zoomScale : number = 100;
    private isAutoZoom : boolean = true;

    // チュートリアルフラグ
    isTutorial = false;
    // 利用規約許諾フラグ
    isLicense = false;

    // フォントロードフラグ
    private isFontLoaded = false;

    // ショートカットキー、およびメニューのID
    static readonly MENU_COMMAND_UNDO = "layout_editor_undo";
    static readonly MENU_COMMAND_REDO = "layout_editor_redo";
    static readonly MENU_SAVE_DOCUMENT = "layout_editor_save_document";

    // 待機
    private isWaiting = false;
    private get waitingTitle() { return "処理中"; }
    private get waitingMessage() { return "処理をしています…"; }

    // ヘッダーで画面から抜ける時の処理
    private onHeaderNavigationStart(link : string)
    {
        if(link == "/DesignEditor" || link == "/PrintSetting")
        {
            // デザイン、印刷に遷移する時に処理中表示
            this.isWaiting = true;
        }
    }

    private onHeaderNavigationFinish(link : string)
    {
        // 処理中を非表示
        this.isWaiting = false;
    }

    // 遷移処理
    // showWait : 待機モーダルを表示する
    private goLink(link : string, showWait : boolean = false)
    {
        if(showWait)
        {
            this.isWaiting = true;
            setTimeout(() =>
            {
                this.isWaiting = false;
                this.$router.push(link);
            }, 50);
        }
        else
        {
            this.$router.push(link);
        }
    }

    private get clipboardManager() : ClipboardManager
    {
        return this.$store.getters.clipboardManager;
    }

    private mounted()
    {
        // ショートカット登録
        this.registerShortcut();
        document.addEventListener("keydown", this.onKeyDown);

        // メッセージセンター登録
        var messageCenter = this.$store.getters.messageCenter;
        messageCenter.subscribe(this, "exec_command", this.processExecCommand);

        if(CookieHelper.getItem("license") != true){
            this.isLicense = true;
        }
        else if(this.flowMode == 0 && CookieHelper.getItem("layoutEditorTutorial") != true){
            this.isTutorial = true;
        }
        else if((this.flowMode == 1 || this.flowMode == 2) && CookieHelper.getItem("insertionLayoutEditorTutorial") != true){
            this.isTutorial = true;
        }

        // TODO 多分もういらないけど残しておく
        // Webfontロード
        FontHelper.loadWebFonts(() =>
        {
            // ロード完了
            this.isFontLoaded = true;
        }, () =>
        {
            // ロード失敗
            this.isFontLoaded = true;
        });

        var param = {};
        param["view"] = "LayoutEditor";
        NativeHelper.sendNativeEvent("view_mounted", param);

        // アンドゥリドゥ変更イベント登録
        this.registerUndoRedoChangeCallback();
    }

    private registerUndoRedoChangeCallback()
    {
        if(this.currentDocument == null) { return; }
        this.currentDocument.undoRedoManager.registerUndoChangeCallback(this.onChangeUndo);
        this.currentDocument.undoRedoManager.registerRedoChangeCallback(this.onChangeRedo);
    }

    private onChangeUndo()
    {
        var param = {};
        param["enabled"] = this.currentDocument.undoRedoManager.canUndo ? "true" : "false";
        NativeHelper.sendNativeEvent("changed_undo_enable", param);
    }

    private onChangeRedo()
    {
        var param = {};
        param["enabled"] = this.currentDocument.undoRedoManager.canRedo ? "true" : "false";
        NativeHelper.sendNativeEvent("changed_redo_enable", param);
    }

    private destroyed()
    {
        // ショートカット解除
        this.unregisterShortcut();
        document.removeEventListener("keydown", this.onKeyDown);

        // メッセージセンター削除
        var messageCenter = this.$store.getters.messageCenter;
        messageCenter.unsubscribe(this, "exec_command");

        // アンドゥリドゥ変更イベント削除
        this.currentDocument.undoRedoManager.clearUndoChangeCallbacks();
        this.currentDocument.undoRedoManager.clearUndoChangeCallbacks();
    }

    // コマンド処理
    private processExecCommand(paramParent : any)
    {
        try
        {
            var command : string = paramParent.command;
            var parameter : any = paramParent.parameter;

            if(command == "import_document")
            {
                // ドキュメント読み込み
                try
                {
                    var json = parameter.document;
                    var jsonData = JSON.parse(json);
                    var importDocument = Document.createFromJsonData(jsonData);
                    if(importDocument.useInsertion)
                    {
                        // 差し込みは読み込まない
                        NativeHelper.sendNativeEvent("import_document_error", { about : "useInsertion" });
                        return;
                    }
                    this.$store.dispatch("setDocument", importDocument);
                    // 読み込み完了フラグON *少し遅延させないと画像読み込みが遅れる
                    setTimeout(() =>
                    {
                        this.isLoadedDocument = true;
                        // アンドゥリドゥ変更イベント登録
                        this.registerUndoRedoChangeCallback();
                    }, 100);
                }
                catch(eDoc)
                {
                    // ドキュメント読み込み独自でエラーチェックする
                    NativeHelper.sendNativeEvent("import_document_error", { about : "invalid" });
                }
            }
            else if(command == "insert_design")
            {
                // デザイン挿入

                // デザインのパース
                var json = parameter.design;
                var jsonData = JSON.parse(json);
                var insertDesign = Design.createFromJsonData(jsonData);
                // 挿入先の設定
                var pageIndex = Number(parameter.page);
                var isReverse = parameter.isReverse == "true";
                var position = Number(parameter.position);
                // コマンド実行
                this.insertDesign(insertDesign, pageIndex, isReverse, position);
            }
            else if(command == "delete_design")
            {
                // デザインの削除
                this.deleteDesign(Number(parameter.position));
            }
            else if(command == "add_page")
            {
                // ページ追加
                this.addPage();
            }
            else if(command == "next_page")
            {
                // 次のページへ
                this.goPage(this.currentDocument.currentPageIndex + 1);
            }
            else if(command == "back_page")
            {
                // 前のページへ
                this.goPage(this.currentDocument.currentPageIndex - 1);
            }
            else if(command == "delete_page")
            {
                // ページ削除
                this.deletePage();
            }
            else if(command == "undo")
            {
                // アンドゥ
                this.undo();
            }
            else if(command == "redo")
            {
                // リドゥ
                this.redo();
            }
            else if(command == "rotate_document")
            {
                // ドキュメントの回転
                var delta = parameter != null && parameter.rotate != null ? Number(parameter.rotate) : 90;
                this.rotateDocument(delta);
            }
            else if(command == "reverse_surface")
            {
                // 面を逆にする
                if(this.currentDocument.hasReverseSurface)
                {
                    this.changeSurface(!this.currentDocument.isReverseSurface);
                }
            }
            else if(command == "copy_design_horizontal")
            {
                // 横一列コピー
                this.copyHorizontal();
            }
            else if(command == "copy_design_vertical")
            {
                // 縦一列コピー
                this.copyVertical();
            }
            else if(command == "copy_design_all")
            {
                // 全面コピー
                this.copyAll();
            }
            else if(command == "copy_design_selected")
            {
                // 選択してコピー
                var surface = this.currentPage.getSurface(this.currentDocument.isReverseSurface);
                var currentDesign = surface.getDesign(this.currentPage.currentDesignPosition);
                if(currentDesign != null)
                {
                    this.$store.getters.applicationState.layoutCopyMode = 1;
                    this.$store.getters.applicationState.layoutCopyPage = this.currentDocument.currentPageIndex;
                    this.$store.getters.applicationState.layoutCopyPosition = this.currentPage.currentDesignPosition;
                    this.$store.getters.applicationState.layoutCopyReverse = this.currentDocument.isReverseSurface;

                    // クリップボードへコピー
                    this.copyDesign(currentDesign, true);
                    // コピー開始通知
                    NativeHelper.sendNativeEvent("copy_design_selected_start", {});
                }
                else
                {
                    // デザインがなかった
                    // コピー対象なし通知
                    NativeHelper.sendNativeEvent("copy_design_selected_nothing", {});
                }
            }
            else if(command == "copy_design_selected_decide")
            {
                // 選択してコピー : 決定

                // 上書きするか?
                var override = parameter != null && parameter.override != null && parameter.override == "true";
                var surface = this.currentPage.getSurface(this.currentDocument.isReverseSurface);
                var targetDesign = surface.getDesign(this.currentPage.currentDesignPosition);

                if(this.$store.getters.applicationState.layoutCopyPage == this.currentDocument.currentPageIndex &&
                    this.$store.getters.applicationState.layoutCopyPosition == this.currentPage.currentDesignPosition &&
                    this.$store.getters.applicationState.layoutCopyReverse == this.currentDocument.isReverseSurface)
                {
                    // コピー元と同じ場所
                    NativeHelper.sendNativeEvent("copy_design_selected_paste_to_same", {});
                }
                else if(targetDesign != null && targetDesign.hasAnyObject() && !override)
                {
                    // オブジェクトが存在している かつ 上書きでない
                    NativeHelper.sendNativeEvent("copy_design_selected_paste_to_exist", {});
                }
                else
                {
                    // オブジェクトがない or 上書き
                    this.pasteDesign(this.currentPage.currentDesignPosition, true);
                    NativeHelper.sendNativeEvent("copy_design_selected_paste_to_done", {});

                    this.$store.getters.applicationState.layoutCopyMode = 0;
                    this.$store.getters.applicationState.layoutCopyPage = 0;
                    this.$store.getters.applicationState.layoutCopyPosition = 0;
                }
            }
            else if(command == "copy_design_selected_cancel")
            {
                // 選択してコピー : キャンセル
                this.$store.getters.applicationState.layoutCopyMode = 0;
                this.$store.getters.applicationState.layoutCopyPage = 0;
                this.$store.getters.applicationState.layoutCopyPosition = 0;

                NativeHelper.sendNativeEvent("copy_design_selected_canceled", {});
            }
        }
        catch(ex)
        {
            DebugHelper.trace(ex);
        }
    }

    private registerShortcut()
    {
        // ショートカット登録
        var manager : ShortcutManager = this.$store.getters.shortcutManager;
        manager.addKeyboardShortcut(LayoutEditor.MENU_COMMAND_UNDO, "ctrl", "z", () => this.executeCommand(LayoutEditor.MENU_COMMAND_UNDO), () => this.canExecuteCommand(LayoutEditor.MENU_COMMAND_UNDO));
        manager.addKeyboardShortcut(LayoutEditor.MENU_COMMAND_REDO, "ctrl + shift", "z", () => this.executeCommand(LayoutEditor.MENU_COMMAND_REDO), () => this.canExecuteCommand(LayoutEditor.MENU_COMMAND_REDO));
        manager.addKeyboardShortcut(LayoutEditor.MENU_SAVE_DOCUMENT, "ctrl", "s", () => this.executeCommand(LayoutEditor.MENU_SAVE_DOCUMENT), () => this.canExecuteCommand(LayoutEditor.MENU_SAVE_DOCUMENT));
    }

    // メニューコマンド処理
    private canExecuteCommand(key) : boolean
    {
        var canExecute = false;
        if(key == LayoutEditor.MENU_COMMAND_UNDO)
        {
            canExecute = this.currentDocument.undoRedoManager.canUndo;
        }
        else if(key == LayoutEditor.MENU_COMMAND_REDO)
        {
            canExecute = this.currentDocument.undoRedoManager.canRedo;
        }
        else if(key == LayoutEditor.MENU_SAVE_DOCUMENT)
        {
            canExecute = true;
        }

        return canExecute;
    }

    private executeCommand(key) : void
    {
        if(key == LayoutEditor.MENU_COMMAND_UNDO)
        {
            this.undo();
        }
        else if(key == LayoutEditor.MENU_COMMAND_REDO)
        {
            this.redo();
        }
        else if(key == LayoutEditor.MENU_SAVE_DOCUMENT)
        {
            this.saveDocument();
        }
    }

    private unregisterShortcut()
    {
        // ショートカット解除
        var manager : ShortcutManager = this.$store.getters.shortcutManager;
        manager.removeKeyboardShortcut(LayoutEditor.MENU_COMMAND_UNDO);
        manager.removeKeyboardShortcut(LayoutEditor.MENU_COMMAND_REDO);
        manager.removeKeyboardShortcut(LayoutEditor.MENU_SAVE_DOCUMENT);
    }

    private onKeyDown(event)
    {
        // ショートカット実行
        var manager : ShortcutManager = this.$store.getters.shortcutManager;
        manager.doKeyboardShortcutIfNeeded(event);
    }

    public get currentDocument() : Document
    {
      	return this.$store.getters.document;
    }

    public get pageList() : Array<Page>
    {
        var document = this.currentDocument;
        if(document.useInsertion)
        {
            // 印刷設定のページを取得
            return InsertionHelper.createPageList(document, true);
        }
        else
        {
            return document.pageList;
        }
    }

    public get currentPage() : Page
    {
        return this.pageList[this.currentDocument.currentPageIndex];
    }

    private get isReverseSurface()
    {
        var document = this.currentDocument;
        return document.isReverseSurface;
    }

    private get bleedSize()
    {
        return this.$store.getters.userConfig.bleedSize;
    }

    public get currentPageNumber() : number
    {
        return this.currentDocument.currentPageIndex + 1;
    }

    private get documentRotate() : number
    {
        return this.currentDocument.rotate;
    }

	// すべてのドキュメントへの編集は、このクラスから行う
	// action - mutation モデルへの移行も視野に入れている

	// コマンドのコール
	private onDoCommand(command : string, parameter : any)
	{
        if(command == "selectDesign")
        {
            // デザインの選択
            this.selectDesign(parameter.position);
        }
        else if(command == "goPage")
        {
            // ページ変更
            this.goPage(parameter.page);
        }
        else if(command == "saveDocument")
        {
            // ドキュメントを保存
            this.saveDocument();
        }
        else if(command == "copyVertical")
        {
            // 縦一列にデザインをコピー
            this.copyVertical();
        }
        else if(command == "copyHorizontal")
        {
            // 横一列にデザインをコピー
            this.copyHorizontal();
        }
        else if(command == "copyAll")
        {
            // 全面にデザインをコピー
            this.copyAll();
        }
        else if(command == "addPage")
        {
            // ページを追加
            this.addPage();
        }
        else if(command == "deletePage")
        {
            // ページを削除
            this.deletePage();
        }
        else if(command == "createDesign")
        {
            // 新規デザイン
            this.createDesign();
        }
        else if(command == "deleteAll")
        {
            // 全デザイン削除
            this.showDeleteDesignModal();
            this.deleteDesignIndex = -1;

        }
        else if(command == "deleteDesign")
        {
            // デザイン削除
            this.showDeleteDesignModal();
            this.deleteDesignIndex = this.currentPage.currentDesignPosition;
        }
        else if(command == "moveDesign")
        {
            // デザイン移動
            this.moveDesign(parameter.from, parameter.to);
        }
        else if(command == "saveDocument")
        {
            // 印刷ファイル保存
            this.saveDocument();
        }
        else if(command == "goNext")
        {
            // 次へ
            this.goNext();
        }
        else if(command == "changeSurface")
        {
            // 表面、裏面変更
            this.changeSurface(parameter.isReverse);
        }
        else if(command == "showContextMenu")
        {
            // コンテキストメニュー表示
            this.showContextMenu(parameter.event);
        }
        else if(command == "changeZoomScale")
        {
            // ズーム倍率変更
            var isAutoZoomOff = (parameter.isAutoZoomOff != null) ? parameter.isAutoZoomOff : false;
            this.changeZoomScale(parameter.scale, isAutoZoomOff);
        }
        else if(command == "changeAutoZoom")
        {
            // 自動ズーム切り替え
            this.changeAutoZoom(parameter.isAutoZoom);
        }
        else if(command == "undo")
        {
            // アンドゥ
            this.undo();
        }
        else if(command == "redo")
        {
            // リドゥ
            this.redo();
        }
        else if(command == "changeUserConfig")
        {
            // ユーザー設定変更
            this.changeUserConfig(parameter.propertyName, parameter.value);
        }
        else if(command == "rotateDocument")
        {
            // ドキュメントの回転
            this.rotateDocument(parameter.delta);
        }
        else if(command == "loadDocument")
        {
            // ドキュメントのロード
            this.loadDocument();
        }
        else if(command == "startDragDesign")
        {
            // デザインのドラッグを開始する
            this.draggingItemPosition = parameter.position;
        }
        else if(command == "endDragDesign")
        {
            // デザインのドラッグを終了する
            this.draggingItemPosition = -1;
        }
        else if(command == "dropOutside")
        {
            // 外側にドロップする
            if(0 <= this.draggingItemPosition && this.draggingItemPosition < this.currentPage.designMaxNumber)
            {

                this.showDeleteDesignModal()
                this.deleteDesignIndex = this.draggingItemPosition;
            }
        }
        else if(command == "dropToDesign")
        {
            // デザインにドロップする
            var to = parameter.position;
            if(0 <= to && to < this.currentPage.designMaxNumber)
            {
                if(0 <= this.draggingMaterialIndex && this.draggingMaterialIndex < this.currentPage.designMaxNumber)
                {
                    // 素材のドロップ
                    this.dropDesignMaterial(this.draggingMaterialIndex, to);
                }
                if(0 <= this.draggingItemPosition && this.draggingItemPosition < this.currentPage.designMaxNumber)
                {
                    // 移動
                    this.moveDesign(this.draggingItemPosition, to);
                }
            }
        }
        else if(command == "startDragMaterial")
        {
            // デザイン素材のドラッグ開始
            this.draggingMaterialIndex = parameter.index;
        }
        else if(command == "endDragMaterial")
        {
            // デザイン素材のドラッグ終了
            this.draggingMaterialIndex = -1;
        }
        else if(command == "setOffset")
        {
            // 差し込み開始面変更
            this.setOffset(parameter.offset);
        }
        else if(command == "setStartRow")
        {
            // 開始行変更
            this.setStartRow(parameter.row);
        }
        else if(command == "setEndRow")
        {
            // 終了行変更
            this.setEndRow(parameter.row);
        }
        else if(command == "setPrintCount")
        {
            // 差し込み印刷枚数変更
            this.setPrintCount(parameter.count);
        }
        else if(command == "setInsertionDirection")
        {
            // 差し込み方向変更
            this.setInsertionDirection(parameter.direction);
        }
    }

    // デザインの選択
    private selectDesign(position : number)
    {
        // アンドゥ・リドゥの対象外
        this.currentPage.currentDesignPosition = position;
        // イベント発行
        var design = this.currentPage.getSurface(this.isReverseSurface).getDesign(position);
        var param = {};
        var existType = 0;
        if(design != null)
        {
            if(design.hasAnyObject(false)) { existType = 3; }
            else if(design.hasAnyObject(true)) { existType = 2; }
            else { existType = 1; }
        }
        param["existType"] = "" + existType;
        param["page"] = "" + this.currentDocument.currentPageIndex;
        param["isReverse"] = this.isReverseSurface ? "true" : "false";
        param["position"] = position;
        NativeHelper.sendNativeEvent("selected_design", param);
    }

    // ページの移動
    private goPage(page : number)
    {
        // アンドゥ・リドゥの対象外
        if(page < 0 || this.pageList.length <= page) { return; }
        this.currentDocument.currentPageIndex = page;
    }

    // デザインの複製
    private duplicateDesign(isHorizontal : boolean, isVertical : boolean)
    {
        var command = new DuplicateDesignCommand(this.currentPage.currentDesignPosition, this.currentPage, this.isReverseSurface, isHorizontal, isVertical, () => {});
        this.currentDocument.undoRedoManager.do(command);
    }

    // 縦一列にデザインをコピー
    private copyVertical(isClipboard = false, doCommand : boolean = true)
    {
        // 現在のドキュメントから縦一列にあるpositionを得る
        var targetPositionArray = this.currentDocument.getVerticalPositionArray(this.currentPage.currentDesignPosition);
        return this.copyDesignCore(isClipboard, targetPositionArray, doCommand);
    }

    // 横一列にデザインをコピー
    private copyHorizontal(isClipboard = false, doCommand = true)
    {
        // 現在のドキュメントから横一列にあるpositionを得る
        var targetPositionArray = this.currentDocument.getHorizontalPositionArray(this.currentPage.currentDesignPosition);
        return this.copyDesignCore(isClipboard, targetPositionArray, doCommand);
    }

    // 全面にデザインをコピー
    private copyAll(isClipboard = false, doCommand : boolean = true)
    {
        // 現在のドキュメントから全面にあるpositionを得る
        var targetPositionArray = this.currentDocument.getFramePositionArray(this.currentPage.currentDesignPosition);
        return this.copyDesignCore(isClipboard, targetPositionArray, doCommand);
    }

    // デザインコピーメイン処理
    private copyDesignCore(isClipboard, targetPositionArray : Array<number>, doCommand : boolean = true)
    {
        var result = false;
        if(targetPositionArray.length >= 1)
        {
            // 現在選択中のデザイン。クリップボードからの場合はクリップボード
            var surface = this.currentPage.getSurface(this.isReverseSurface);
            var design = isClipboard ? this.clipboardManager.getAsDesign() : surface.getDesign(this.currentPage.currentDesignPosition);
            if(design != null)
            {
                var fixPositionArray : Array<number> = [];
                for(var i = 0; i < targetPositionArray.length; ++i)
                {
                    // クリップボードではない場合、ターゲットが自身の場合はコピーしない。
                    if(!isClipboard && this.currentPage.currentDesignPosition == targetPositionArray[i]) { continue; }
                    fixPositionArray.push(targetPositionArray[i]);
                }
                if(fixPositionArray.length > 0)
                {
                    if(doCommand)
                    {
                        var startCallback = () =>
                        {
                            // コピー開始
                            this.isWaiting = true;
                        };
                        var finishCallback = () =>
                        {
                            // コピー終了
                            this.isWaiting = false;
                        };
                        var command = new CopyMultiDesignCommand(design, surface, fixPositionArray, startCallback, finishCallback)
                        this.currentDocument.undoRedoManager.do(command);
                    }
                    result = true;
                }
            }
        }

        return result;
    }

    // ページを今のページの次に追加
    private addPage()
    {
        // ページ最大数チェック
        if(this.currentDocument.pageCount >= Const.MAX_PAGE_NUMBER)
        {
            DebugHelper.trace("ページ最大数");
            return;
        }

        var command = new NewPageCommand(this.currentDocument.currentPageIndex + 1, this.currentDocument, () => {});
        this.currentDocument.undoRedoManager.do(command);
    }

    // 現在のページを削除
    private deletePage()
    {
        // 残りページが1ページの場合は消せない
        if(this.currentDocument.pageList.length <= 1) { return; }

        var command = new DeletePageCommand(this.currentDocument.currentPageIndex, this.currentDocument, () => {});
        this.currentDocument.undoRedoManager.do(command);
    }

    // 新規デザイン
    private createDesign()
    {
        // すでにデザインが存在している場合は新規作成しない
        if(this.currentPage.getSurface(this.isReverseSurface).getDesign(this.currentPage.currentDesignPosition) != null)
        {
            // デザインエディターに遷移
            this.goLink("/DesignEditor", true);
            return;
        }

        // テンプレート選択に遷移
        this.goLink("/SelectTemplate", false);
    }

    // 次へ
    private goNext()
    {
        // 印刷設定画面へ
        this.goLink("/PrintSetting", true);
    }

    // デザインをクリップボードにコピー
    private copyDesign(design, doCommand : boolean = true)
    {
        var result = false;
        if(design != null)
        {
            // クリップボードにコピー
            if(doCommand)
            {
                this.clipboardManager.copy(design.clone());
            }
            result = true;
        }
        return result;
    }

    // デザインをクリップボードから貼り付け
    private pasteDesign(position, doCommand : boolean = true)
    {
        var targetPositionArray = [position];
        return this.copyDesignCore(true, targetPositionArray, doCommand);
    }

    // 全デザインを削除
    private deleteAllDesign(doCommand : boolean = true)
    {
        var result = false;
        for(var i = 0; i < this.currentPage.designMaxNumber; ++i)
        {
            var design = this.currentPage.getSurface(this.isReverseSurface).getDesign(i);
            if(design != null)
            {
                if(doCommand)
                {
                    var command = new DeleteDesignCommand(i, this.currentPage, this.isReverseSurface, () => {});
                    this.currentDocument.undoRedoManager.doAsMultiCommand(command);
                }
                result = true;
            }
        }

        if(result && doCommand)
        {
            this.currentDocument.undoRedoManager.fixMultiCommand();
        }

        return result;
    }

    // デザインを削除
    private deleteDesign(position, doCommand : boolean = true)
    {
        var result = false;
        var design = this.currentPage.getSurface(this.isReverseSurface).getDesign(position);
        if(design != null)
        {
            if(doCommand)
            {
                var command = new DeleteDesignCommand(position, this.currentPage, this.isReverseSurface, () => {});
                this.currentDocument.undoRedoManager.do(command);
            }
            result = true;
        }
        return result;
    }

    // デザインを移動
    private moveDesign(from : number, to : number, doCommand : boolean = true)
    {
        var result = false;

        if(from != to)
        {
            var fromDesign = this.currentPage.getSurface(this.isReverseSurface).getDesign(from);
            var toDesign = this.currentPage.getSurface(this.isReverseSurface).getDesign(to);
            if(fromDesign != null)
            {
                if(doCommand)
                {
                    // コピー
                    var copyCommand = new CopyDesignCommand(fromDesign, to, this.currentPage, this.isReverseSurface, () => {});
                    this.currentDocument.undoRedoManager.doAsMultiCommand(copyCommand, false);
                    // 削除
                    var deteteCommand = new DeleteDesignCommand(from, this.currentPage, this.isReverseSurface, () => {});
                    this.currentDocument.undoRedoManager.doAsMultiCommand(deteteCommand, true);

                    // カレントを移動先にする
                    this.currentPage.currentDesignPosition = to;
                }
                result = true;
            }
        }
        return result;
    }

    // デザインを素材から貼り付け
    private dropDesignMaterial(index : number, to : number, doCommand : boolean = true)
    {
        var result = false;
        var designMaterials = this.$store.getters.userConfig.designMaterials;
        if(0 <= index && index < designMaterials.length)
        {
            var matrial = designMaterials[index];
            var toDesign = this.currentPage.getSurface(this.isReverseSurface).getDesign(to);

            if(doCommand)
            {
                var command = new CopyDesignCommand(matrial, to, this.currentPage, this.isReverseSurface, () => {});
                this.currentDocument.undoRedoManager.do(command);

                // カレントを移動先にする
                this.currentPage.currentDesignPosition = to;
            }
            result = true;
        }

        return result;
    }

    // デザインを編集
    private editDesign()
    {
        this.createDesign();
    }

    // 表面・裏面変更
    private changeSurface(isReverse : boolean)
    {
        this.currentDocument.setSurface(isReverse);
    }

    // コンテキストメニュー表示
    private showContextMenu(event)
    {
        var contextMenu = this.$refs.menu as ContextMenu;
        if(contextMenu != null)
        {
            // menuItems
            var menuItems = new Array();
            var currentDesign = this.currentPage.getSurface(this.isReverseSurface).getDesign(this.currentPage.currentDesignPosition);
            menuItems.push({ text : "コピー", isEnable : this.copyDesign(currentDesign, false),  callback : () => { this.copyDesign(currentDesign); } });
            menuItems.push({ text : "貼り付け", isEnable : this.pasteDesign(this.currentPage.currentDesignPosition, false), callback : () => { this.pasteDesign(this.currentPage.currentDesignPosition); } });
            // menuItems.push({ text : "削除", isEnable : this.deleteDesign(this.currentPage.currentDesignPosition, false),  callback : () => { this.deleteDesignModalActive("deleteDesign" , {position : this.currentPage.currentDesignPosition}) } });
            menuItems.push({ text : "縦一列にコピー", isEnable : this.copyVertical(true, false),  callback : () => { this.copyVertical(true); } });
            menuItems.push({ text : "横一行にコピー", isEnable : this.copyHorizontal(true, false),  callback : () => { this.copyHorizontal(true); } });
            menuItems.push({ text : "ページ全体にコピー", isEnable : this.copyAll(true, false), callback : () => { this.copyAll(true); } });
            if(this.copyDesign(currentDesign, false)){
                menuItems.push({ text : "デザイン編集" , isEnable : true, callback : () => this.editDesign() });
            }else{
                menuItems.push({ text : "デザイン作成" , isEnable : true, callback : () => this.editDesign() });
            }
            menuItems.push({ text : "削除", isEnable : true, callback : () => {
                this.showDeleteDesignModal();
                this.deleteDesignIndex = this.currentPage.currentDesignPosition;
            }});
            contextMenu.open(event, menuItems);
        }
    }

    // ズーム倍率変更
    private changeZoomScale(scale, isAutoZoomOff)
    {
        this.zoomScale = scale;

        // オートズーム解除
        if(isAutoZoomOff && this.isAutoZoom) { this.isAutoZoom = false; }
    }

    // 自動ズーム切り替え
    private changeAutoZoom(isAutoZoom)
    {
        this.isAutoZoom = isAutoZoom;
    }

    // アンドゥ
    private undo()
    {
        if(this.currentDocument.undoRedoManager.canUndo)
        {
            this.currentDocument.undoRedoManager.undo();
        }
    }

    // リドゥ
    private redo()
    {
        if(this.currentDocument.undoRedoManager.canRedo)
        {
            this.currentDocument.undoRedoManager.redo();
        }
    }

    // ユーザー設定変更
    private changeUserConfig(propertyName : string, value : any)
    {
        var userConfig = this.$store.getters.userConfig;
        if(userConfig != null)
        {
            if(userConfig[propertyName] != null)
            {
                userConfig[propertyName] = value;
            }
        }
    }

    // ドキュメントの回転
    private rotateDocument(delta : number)
    {
        // オートリサイズを切る
        this.isAutoZoom = false;
        var command = new RotateDocumentCommand(this.currentDocument, delta, () => {});
        this.currentDocument.undoRedoManager.do(command);
        // オートリサイズを復帰して画面表示を調整する
        this.$nextTick(() => this.isAutoZoom = true);
    }

    // 印刷ファイル保存
    private saveDocument()
    {
        // 開いた時のファイル名があればそれを使う
        var fileName = this.currentDocument.openedFileName != "" ? FileHelper.getFilenameWithoutExtension(this.currentDocument.openedFileName) : NameHelper.createNewDocumentFileName(this.currentDocument);
        FileHelper.saveDocument(this.currentDocument, fileName);
        this.sendSaveLog();
    }

    // 履歴送信
    private sendSaveLog()
    {
        var logValue = {
            productId : this.currentDocument.productId,
            code : this.currentDocument.paperCode,
            templateId : this.$store.getters.data.selectedTemplate.id,
            cloud : 0
        }

        LogHelper.sendLog("1000", logValue);
    }

    // ページ数
    public get maxPage() : number
    {
        return this.pageList.length;
    }

    // ドキュメントのロード
    // ライトコントローラに貼り付け用のデザインをセットする
    // 通常は全デザイン(オブジェクト存在のみ)
    // 差し込みは第１デザイン
    private loadDocument()
    {
        var fileOpen = this.$refs.fileOpen as FileOpen;
        fileOpen.open();
    }

    private onDocumentTextLoaded(text : string, fileType : string, readType : string)
    {
        var document : Document | null = null;
        if(fileType == "document" && readType == "binary")
        {
            document = this.createDocumentFromLabel9FileText(text);
        }
        else
        {
            document = this.createDocumentFromFileText(text);
        }

        if(document == null) { return; }

        var completion = () =>
        {
            if(document == null) { return; }

            // Documentからデザインを取得していき、素材に追加する
            var designMaterials = ArrayHelper.clone(this.$store.getters.userConfig.designMaterials);
            for(var pageIndex = 0; pageIndex < document.pageCount; ++pageIndex)
            {
                var page = document.pageList[pageIndex];
                var surfaceCount = page.hasReverse ? 2 : 1;
                for(var surfaceIndex = 0; surfaceIndex < surfaceCount; ++surfaceIndex)
                {
                    var surface = page.getSurface(surfaceIndex > 0);
                    for(var i = 0; i < page.designMaxNumber; ++i)
                    {
                        var design = surface.getDesign(i);
                        if(design != null && design.hasAnyObject(true))
                        {
                            // オブジェクトが存在していれば追加する
                            designMaterials.push(design);
                        }
                    }
                }
            }
            // セット
            this.$store.getters.userConfig.designMaterials = designMaterials;
        };

        var isFontConvertModalVisible = false;
        if(document.unloadedFonts.length > 0)
        {
            // 利用できないフォントがあった場合
            var fontConvertModal = this.$refs.fontConvertModal as FontConvertModal;
            if(fontConvertModal != null)
            {
                // フォントモーダルを開き、OKが押されたときにドキュメントロードする
                isFontConvertModalVisible = true;
                fontConvertModal.open(document.unloadedFonts, completion);
            }
        }

        if(!isFontConvertModalVisible)
        {
            // フォントモーダルを出さない場合はそのままドキュメントロード
            completion();
        }
    }

    private createDocumentFromFileText(text) : Document
    {
        var compositeText = EncryptionHelper.compositeIfNeeded(text);
        var jsonData = JSON.parse(compositeText);
        var document = Document.createFromJsonData(jsonData);
        return document;
    }

    private createDocumentFromLabel9FileText(text) : Document | null
    {
        var fileConverter = new FileConverter(this.$store.getters.fontManager);
        var document = fileConverter.deserializeLabel9FromXml(text);
        return document;
    }

    private isDeleteDesignModalVisible = false;
    private deleteDesignIndex = -1;

    showDeleteDesignModal()
    {
        this.isDeleteDesignModalVisible = true;
    }

    deleteDesignModalCallback()
    {

        if(this.deleteDesignIndex < 0)
        {
            this.deleteAllDesign();
        }
        else
        {
            this.deleteDesign(this.deleteDesignIndex)
        }
    }

    get flowMode(){
        return this.$store.getters.applicationState.flowMode;
    }

    // 差し込み開始面変更
    private setOffset(offset : number)
    {
        this.currentDocument.insertionData.offset = offset;
    }

    // 差し込み開始行変更
    private setStartRow(row : number)
    {
        this.currentDocument.insertionData.startRow = row;
    }

    // 差し込み終了行変更
    private setEndRow(row : number)
    {
        this.currentDocument.insertionData.endRow = row;
    }

    // 差し込み枚数変更
    private setPrintCount(count : number)
    {
        this.currentDocument.insertionData.printCount = count;
    }

    // 差し込み方向変更
    private setInsertionDirection(direction : number)
    {
        this.currentDocument.insertionData.insertionDirection = direction;
    }

    // デザインを挿入する
    private insertDesign(design : Design, pageIndex : number, isReverse : boolean, position : number)
    {
        // ページのカレント変更
        this.goPage(pageIndex);
        // 面変更
        this.changeSurface(isReverse);
        var command = new CopyDesignCommand(design, position, this.currentPage, this.isReverseSurface, () => {});
        this.currentDocument.undoRedoManager.do(command);
        // カレントを移動先にする
        this.currentPage.currentDesignPosition = position;
    }

    //選択中用紙
    get selectedPaper(){
        return this.$store.getters.data.selectedPaper
    }

    private closeLicense(){
        this.isLicense = false;
        if(this.flowMode == 0){
            this.isTutorial = CookieHelper.getItem("layoutEditorTutorial") != true;
        }
        else if(this.flowMode == 1 || this.flowMode == 2){
            this.isTutorial = CookieHelper.getItem("insertionLayoutEditorTutorial") != true;
        }
    }
}

